module.exports = __webpack_public_path__ + "static/media/iPhone15.f329955c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-carousel/new-banner/iPhone15.png
// module id = 527
// module chunks = 0